import { useMemo } from 'react'

import { corporateGroupTableConfigs } from '../../../variables'
import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const roundupConfigs = {
  ...corporateGroupTableConfigs,
  roundupSales: 'price',
  roundupCheckCount: 'number',
  roundupCheckPercent: 'percent',
} as const

const useLocationRoundup = buildMetricValuesHook({
  groupFilterType: 'corporate',
  metrics: {
    groups: ['Roundup'],
  },
  hasSummary: true,
})

const useRoundup = () => {
  const { data, loading } = useLocationRoundup()
  return {
    data: useMemo(() => {
      return data
    }, [data]),
    loading,
  }
}

export default useRoundup
